document.addEventListener('change', function(e) {
  const input = e.target.closest('input[type="radio"]');
  if (!input) return;
  
  const variantPicker = input.closest('variant-picker');
  if (!variantPicker) return;
  
  const fieldset = input.closest('fieldset');
  if (!fieldset) return;
  
  const swatchValue = fieldset.querySelector('.variant-option__swatch-value');
  if (!swatchValue) return;
  
  swatchValue.textContent = input.value;
});
